import React from 'react'
import Sidebar from '../components/mainpage/subcomponent/Sidebar'
import '../components/styles/dashboard.css'
import ApplictionLink from '../components/mainpage/subcomponent/applicationlink/applictionLink'
const MainApplicationLink = () => {
    return (
        <div>
            <Sidebar />
            <div className='container-fluid'>
                <ApplictionLink />
            </div>
        </div>
    )
}

export default MainApplicationLink